// this is used for bedding, furniture categories

import PropTypes from 'prop-types';
import React, { memo } from 'react';
import HelpIcon from '../../images/icon-help.inline.svg';
import Select from 'react-select';
/**
 * @description Render memoized select component
 * @param {Object} props
 * @returns {JSX.Element} Memoized select component
 */
export const NewSelect = memo(function MemoizedSelect(props) {
  const {
    options,
    className,
    name,
    initial,
    hint,
    errors = null,
    handleChange,
    selected,
    disabled,
    isOpen,
    isLoading,
    isSearchable = false,
    ...rest
  } = props;
  const customOptions = [];

  if (initial) {
    customOptions.push({ value: 0, label: initial, isDisabled: true });
  }

  if (options && Array.isArray(options) && options.length > 0) {
    if (name === 'quantity') {
      options.forEach((option) => {
        customOptions.push({ value: option + 1, label: `Qty ${option + 1}` });
      });
    } else {
      (name === 'PILLOW CASES' || name === 'POCKET' || name === 'SIZE') &&
        customOptions.push({ label: name, value: 'default' });
      options.forEach((option, index) => {
        customOptions.push({ value: option.id || index, label: option.label });
      });
    }
  }

  const getValue = () => {
    if (name === 'quantity') {
      return customOptions.find((el) => el.value === selected);
    }
    return options.find((el) => JSON.stringify(el) === JSON.stringify(selected));
  };

  const colourStyles = {
    option: (styles, { isDisabled }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? 'lightgrey' : '',
        cursor: isDisabled ? 'not-allowed' : 'default'
      };
    }
  };

  return (
    <div className={`custom-dropdown-styling ${className} text-left`}>
      <div className="relative mb-4">
        {hint && <HelpIcon className="absolute -top-5 right-0 h-4 w-4" />}
        <Select
          isSearchable={isSearchable}
          isDisabled={disabled}
          {...rest}
          value={getValue()}
          menuIsOpen={isOpen}
          options={customOptions}
          placeholder={name}
          onChange={handleChange}
          isLoading={isLoading}
          isOptionDisabled={(option) => option.value === 'default'}
          styles={colourStyles}
        />
        {errors?.[name] ? <span className="inline-block text-xs text-red-400">{errors?.[name]?.message}</span> : null}
      </div>
    </div>
  );
});

NewSelect.propTypes = {
  className: PropTypes.string,
  errors: PropTypes.array,
  handleChange: PropTypes.func,
  hint: PropTypes.any,
  initial: PropTypes.any,
  name: PropTypes.any,
  options: PropTypes.array
};
